import debounce from 'lodash.debounce';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContainerHeader from '../shared/container/ContainerHeader';
import Search from '../shared/search/Search';
import { setPublicNotesSearchAction } from '../../redux/actions/notesActions';

const PublicNotesHeader = () => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.notes?.publicNotesSearch);

  const debounced = debounce((args) => {
    dispatch(setPublicNotesSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  return (
    <ContainerHeader>
      <Search value={search.search} onChangeAction={handleSearchChange} />
    </ContainerHeader>
  );
};

export default PublicNotesHeader;
